import { Link } from 'react-router-dom';
import { useParallax } from '@/hooks/useParallax';

interface RoleCard {
  title: string;
  subtitle: string;
  path: string;
  width: string;
  offset: { x: number; y: number };
}

const roles: RoleCard[] = [
  {
    title: 'Producer',
    subtitle: '企画プロデュース',
    path: '/producer',
    width: 'w-[70%]',
    offset: { x: 0, y: 0 },
  },
  {
    title: 'Engineer',
    subtitle: 'Web制作',
    path: '/engineer',
    width: 'w-[45%]',
    offset: { x: 24, y: 16 },
  },
  {
    title: 'Creator',
    subtitle: '動画撮影・編集',
    path: '/creator',
    width: 'w-[43%]',
    offset: { x: -8, y: 28 },
  },
  {
    title: 'Servant',
    subtitle: '話を聞く',
    path: '/servant',
    width: 'w-[45%]',
    offset: { x: 16, y: 12 },
  },
  {
    title: 'Instructor',
    subtitle: '暗闇ゆるヨガ',
    path: '/instructor',
    width: 'w-[60%]',
    offset: { x: -12, y: 20 },
  },
];

const FiveRoles = () => {
  const { scrollY, isMobile } = useParallax();

  return (
    <section className="relative py-32 md:py-48 overflow-hidden">
      {/* 背景グラデーション */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bar-deep/30 to-transparent" />
      
      <div className="container mx-auto px-12 md:px-16 lg:px-24">
        {/* セクションタイトル */}
        <div className="mb-20 md:mb-32">
          <p className="text-xs font-display tracking-[0.3em] text-muted-foreground/60 mb-4">
            FIVE ROOMS
          </p>
          <h2 className="text-xl md:text-2xl font-display font-light text-foreground/90 tracking-wide">
            5つの部屋
          </h2>
        </div>

        {/* Broken Grid レイアウト */}
        <div className="relative space-y-6 md:space-y-0 md:grid md:grid-cols-12 md:gap-y-8">
          {roles.map((role, index) => {
            const parallaxOffset = isMobile ? 0 : (scrollY * 0.02 * (index % 3 - 1));
            
            return (
              <Link
                key={role.path}
                to={role.path}
                className={`
                  block ${role.width} 
                  ${index === 0 ? 'md:col-span-8' : ''}
                  ${index === 1 ? 'md:col-span-4 md:col-start-9' : ''}
                  ${index === 2 ? 'md:col-span-4 md:col-start-2' : ''}
                  ${index === 3 ? 'md:col-span-5 md:col-start-7' : ''}
                  ${index === 4 ? 'md:col-span-7 md:col-start-3' : ''}
                `}
                style={{
                  transform: `translate(${isMobile ? 0 : role.offset.x}px, ${role.offset.y + parallaxOffset}px)`,
                }}
              >
                <div className="glass-card-role group px-8 py-10 md:py-14 transition-all duration-700 ease-out hover:scale-[1.005]">
                  {/* 部屋タイトル */}
                  <h3 className="font-display text-lg md:text-xl font-light tracking-[0.12em] text-foreground/90 mb-3 group-hover:tracking-[0.15em] transition-all duration-700">
                    {role.title}
                  </h3>
                  
                  {/* サブタイトル - 1行のみ */}
                  <p className="text-sm text-muted-foreground/70 font-light tracking-wide truncate">
                    {role.subtitle}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FiveRoles;